import type { MeContext, WorkspaceNode } from '@vizit/api';

export function findWorkspaceBySlug(context: MeContext, slug: string): WorkspaceNode | undefined {
  for (const portfolio of context.organization.portfolios) {
    const match = portfolio.workspaces.find((workspace) => workspace.slug === slug);
    if (match) {
      return match;
    }
  }

  return undefined;
}
